import GuideCard from './GuideCard.component';

export default GuideCard;